import UiRippleInk from '../UiRippleInk.vue';

export default {
    props: {
        hideRippleInk: {
            type: Boolean,
            default: false
        }
    },

    components: {
        UiRippleInk
    }
};



/** WEBPACK FOOTER **
 ** ./src/mixins/ShowsRippleInk.js
 **/